import { IS_ACTIVE } from "../_defs";
import { getTarget } from "../functions/_getTarget";

type TabItem = {
  trigger: HTMLElement;
  target: HTMLElement;
};

export const setupTab = (): void => {
  document.querySelectorAll<HTMLElement>("[data-tab]").forEach((tab) => {
    let current: TabItem | undefined;

    const hide = (item: TabItem): void => {
      item.trigger.classList.remove(IS_ACTIVE);
      item.target.classList.remove(IS_ACTIVE);
    };

    const show = (item: TabItem): void => {
      item.trigger.classList.add(IS_ACTIVE);
      item.target.classList.add(IS_ACTIVE);
    };

    const toggle = (item: TabItem): void => {
      if (current) hide(current);

      current = item;

      show(item);
    };

    tab
      .querySelectorAll<HTMLElement>("[data-tab-trigger]")
      .forEach((trigger) => {
        const target = getTarget(trigger);

        if (!(target instanceof HTMLElement)) return;

        const item: TabItem = { trigger, target };

        trigger.addEventListener("click", (ev) => {
          toggle(item);

          ev.preventDefault();
        });

        if (
          trigger.classList.contains(IS_ACTIVE) ||
          target.classList.contains(IS_ACTIVE)
        ) {
          if (current === undefined) {
            current = item;
            show(item);
          } else {
            hide(item);
          }
        }
      });
  });
};
